import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import FormList from './FormList';
import FormCheckbox from './FormCheckbox';

const formSchema = z.object({
  name: z.string(),
  password: z.string(),
  email: z.string(),
});

const ContactForm = () => {
  const {
    register,
    watch,
    getValues,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: { name: '', password: '', email: '' },
  });
  const emailValue = watch('email');
  const maxLength = 35;
  const remains = maxLength - (emailValue?.length || 0);

  const onSubmit = async (data) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const curUserName = getValues('name');
    alert(`Dear ${curUserName}, your form was sent`);
  };
  return (
    <section className='form' id='form'>
      <h2>Form</h2>
      <h3>Choose your beloved crystal</h3>
      <form className='innerForm' onSubmit={handleSubmit(onSubmit)}>
        <div className='formName'>
          <label htmlFor='name'>
            Full Name:
            <br />
          </label>
          <input
            required
            {...register('name')}
            type='text'
            id='name'
            maxLength={35}
            placeholder='Your name'
          />
        </div>
        <div className='formEmail'>
          <label htmlFor='email'>
            Email: <br />
          </label>
          <input
            maxLength={maxLength}
            id='email'
            {...register('email')}
            placeholder='type your email here'
            type='email'
            style={{ marginBottom: '10px' }}
          />{' '}
          <br /> <span>Characters left: {remains}</span>
        </div>
        <div className='formPassword'>
          <label htmlFor='password'>
            Password: <br />
          </label>
          <input
            required
            maxLength={35}
            {...register('password')}
            type='password'
            id='password'
            placeholder='password here'
          />
        </div>
        <FormList className='formList' />
        <div className='emptyForm'></div>
        <FormCheckbox className='formCheckbox' />
        <button className='formBtnSend' disabled={isSubmitting} type='submit'>
          {isSubmitting ? 'Sending...' : 'Send'}
        </button>
      </form>
    </section>
  );
};

export default ContactForm;
